var React = require('react');

function ChefHat (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M17.25,3A3.7,3.7,0,0,0,16,3.23a4.467,4.467,0,0,0-8,0A3.706,3.706,0,0,0,6.75,3a3.75,3.75,0,0,0,0,7.5v5.25h10.5V10.5a3.75,3.75,0,0,0,0-7.5Z","key":1}),React.createElement("path",{"className":"a","d":"M5.936,21.522a3.529,3.529,0,0,0,1.871-1.658A2.251,2.251,0,0,1,12,21c0,1.243-1.5,2.25-3,2.25-3.75,0-3.75-1.5-3.75-1.5Z","key":2}),React.createElement("path",{"className":"a","d":"M18.065,21.522a3.531,3.531,0,0,1-1.872-1.658A2.251,2.251,0,0,0,12,21c0,1.243,1.5,2.25,3,2.25,3.75,0,3.75-1.5,3.75-1.5Z","key":3}),React.createElement("line",{"className":"a","x1":"6.75","y1":"12.75","x2":"17.25","y2":"12.75","key":4}),React.createElement("line",{"className":"a","x1":"9.75","y1":"12.75","x2":"9.75","y2":"11.25","key":5}),React.createElement("line",{"className":"a","x1":"14.25","y1":"12.75","x2":"14.25","y2":"11.25","key":6})]);
}

ChefHat.defaultProps = {"id":"Regular","viewBox":"0 0 24 24"};

module.exports = ChefHat;

ChefHat.default = ChefHat;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/chef-hat.svg
// module id = 1062
// module chunks = 0